import { createContext, useContext } from 'react';
import { type DebugJourneyDataFragment } from '../../../../api/fragments/DebugJourneyData';

type ExtraData = {
    application:
        | Extract<DebugJourneyDataFragment['application'], { __typename: 'MobilityApplication' }>
        | null
        | undefined;
    token: string | null | undefined;
    isAmend: boolean;
    isCancel: boolean;
};

export const ExtraDataContext = createContext<ExtraData | null>(null);
export const useExtraDataContext = () => useContext(ExtraDataContext);
